(() => {
  const key = 'miss-care-wishlist-v1';
  let items = [], storageAvailable = true, opener;
  const safeUrl = (value, image = false) => {
    try {
      const url = new URL(value, location.origin);
      return image ? url.protocol === 'https:' || url.origin === location.origin : url.origin === location.origin && /\/products\//.test(url.pathname);
    } catch (_) { return false; }
  };
  function read() {
    try {
      const saved = JSON.parse(localStorage.getItem(key) || '[]');
      items = Array.isArray(saved) ? saved.filter(item => item && typeof item.handle === 'string' && typeof item.title === 'string' && safeUrl(item.url)).slice(0, 100) : [];
    } catch (_) { storageAvailable = false; items = []; }
  }
  const dialog = document.createElement('dialog');
  dialog.className = 'mc-wishlist-dialog';
  dialog.setAttribute('aria-labelledby', 'mc-wishlist-title');
  dialog.innerHTML = '<div class="mc-wishlist-head"><h2 id="mc-wishlist-title">Your wishlist</h2><button type="button" data-wishlist-close aria-label="Close wishlist">&times;</button></div><p class="mc-wishlist-note"></p><div class="mc-wishlist-items"></div><p class="mc-wishlist-status" role="status" aria-live="polite"></p>';
  document.body.append(dialog);
  const list = dialog.querySelector('.mc-wishlist-items');
  const note = dialog.querySelector('.mc-wishlist-note');
  const status = dialog.querySelector('.mc-wishlist-status');
  function sync() {
    document.querySelectorAll('#wishCount,[data-wishlist-count]').forEach(el => el.textContent = items.length);
    document.querySelectorAll('[data-wish-product]').forEach(button => {
      const saved = items.some(item => item.handle === button.dataset.handle);
      button.setAttribute('aria-pressed', String(saved));
      button.setAttribute('aria-label', `${saved ? 'Remove' : 'Save'} ${button.dataset.title} ${saved ? 'from' : 'to'} wishlist`);
      const label = button.querySelector('span');
      const text = saved ? 'Saved to wishlist' : 'Save to wishlist';
      if (label && label.textContent !== text) label.textContent = text;
    });
  }
  function persist() {
    try { localStorage.setItem(key, JSON.stringify(items)); storageAvailable = true; }
    catch (_) { storageAvailable = false; }
    sync();
  }
  function render() {
    list.replaceChildren();
    note.textContent = storageAvailable ? 'Saved in this browser. Open a product for its current price and availability.' : 'Browser storage is unavailable. Your wishlist will only last for this visit.';
    if (!items.length) {
      const empty = document.createElement('p');
      empty.textContent = 'Your wishlist is empty. Tap a product heart to save something you love.';
      const browse = document.createElement('a');
      browse.href = '/collections/all'; browse.className = 'mc-refresh-button'; browse.textContent = 'Explore the collection';
      list.append(empty, browse);
      return;
    }
    items.forEach(item => {
      const row = document.createElement('article');
      row.className = 'mc-wishlist-item';
      const link = document.createElement('a');
      link.href = item.url;
      if (item.image && safeUrl(item.image, true)) {
        const image = document.createElement('img');
        image.src = item.image; image.alt = ''; image.width = 72; image.height = 88; image.loading = 'lazy';
        image.addEventListener('error', () => image.hidden = true, { once: true });
        link.append(image);
      }
      const title = document.createElement('span'); title.textContent = item.title; link.append(title);
      const remove = document.createElement('button');
      remove.type = 'button'; remove.textContent = 'Remove'; remove.setAttribute('aria-label', `Remove ${item.title} from wishlist`);
      remove.addEventListener('click', () => {
        const index = items.findIndex(saved => saved.handle === item.handle);
        items = items.filter(saved => saved.handle !== item.handle); persist(); render();
        status.textContent = 'Product removed from your wishlist.';
        (list.querySelectorAll('button')[Math.min(index, items.length - 1)] || dialog.querySelector('[data-wishlist-close]')).focus();
      });
      row.append(link, remove); list.append(row);
    });
  }
  document.addEventListener('click', event => {
    const save = event.target.closest('[data-wish-product]');
    if (save) {
      event.preventDefault();
      const exists = items.some(item => item.handle === save.dataset.handle);
      if (exists) items = items.filter(item => item.handle !== save.dataset.handle);
      else if (safeUrl(save.dataset.url) && items.length < 100) items.push({handle:save.dataset.handle,title:save.dataset.title,url:save.dataset.url,image:save.dataset.image});
      persist();
      if (!storageAvailable || (!exists && items.length >= 100)) {
        opener = save; render(); status.textContent = !storageAvailable ? 'Saving between visits is unavailable in this browser.' : 'Your wishlist holds up to 100 products.'; dialog.showModal();
      }
    }
    const trigger = event.target.closest('[data-wishlist-open]');
    if (trigger) {
      opener = trigger.closest('#drawer') ? document.getElementById('menuBtn') : trigger;
      if (trigger.closest('#drawer')) document.getElementById('drawerClose')?.click();
      render(); status.textContent = ''; dialog.showModal();
    }
  });
  dialog.querySelector('[data-wishlist-close]').addEventListener('click', () => dialog.close());
  dialog.addEventListener('close', () => opener?.focus());
  window.addEventListener('storage', event => { if (event.key === key || event.key === null) { read(); sync(); if (dialog.open) render(); } });
  document.addEventListener('shopify:section:load', sync);
  new MutationObserver(sync).observe(document.getElementById('MainContent') || document.body, {childList:true,subtree:true});
  read(); sync();
})();
